import { HIDE_LOADER_GALLERY, SHOW_LOADER_GALLERY } from '../actionTypes/LoaderActionTypes';

export const showLoader = () => ({
    type: SHOW_LOADER_GALLERY,
});

export const hideLoader = () => ({
    type: HIDE_LOADER_GALLERY,
});
